var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.styles.pill, { [_vm.styles[`pill-${_vm.pill_class}`]]: _vm.pill_class != null}, _vm.pill_position]},[(_vm.pill_title != null)?_c('div',[_vm._v(_vm._s(_vm.pill_title))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }